import { Brand, Type, Environment } from '.';
export var checkNewTeamViewUrlEnabled = function () {
    if (typeof window !== 'undefined') {
        if (window.location.hostname && window.location.hostname.indexOf('lendigroup.com.au') !== -1) {
            return true;
        }
        return false;
    }
    return undefined;
};
function getBaseURL(brand, type, environment, lendiGroupTeamView) {
    if (typeof window !== 'undefined') {
        switch (window.location.hostname) {
            case 'www.lendi.com.au.local':
            case 'team.lendi.com.au.local':
            case 'team.aussie.com.au.local':
                return location.origin;
        }
        if (window.location.hostname && window.location.hostname.indexOf('test.lendi-dev.net') >= 0) {
            return location.origin;
        }
    }
    // We need this explicit check on lendigroup_tv cookie because getBaseURL is exposed to multiple consumers, so they might miss to pass this flag to support new TV url
    var lendiGroupTvEnabled = type === Type.Team && lendiGroupTeamView === undefined ? checkNewTeamViewUrlEnabled() : lendiGroupTeamView;
    if (brand === Brand.Lendi && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return !lendiGroupTvEnabled ? 'https://team.lendi-dev.net' : 'https://lendi-team-dev.lendigroup.com.au';
            case Environment.Staging:
                return !lendiGroupTvEnabled ? 'https://team.lendi-stg.net' : 'https://lendi-team-stg.lendigroup.com.au';
            case Environment.Preproduction:
                return !lendiGroupTvEnabled ? 'https://team.lendi-preprod.net' : 'https://lendi-team-preprod.lendigroup.com.au';
            case Environment.Production:
                return !lendiGroupTvEnabled ? 'https://team.lendi.com.au' : 'https://lendi-team.lendigroup.com.au';
        }
    }
    if (brand === Brand.Aussie && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return !lendiGroupTvEnabled ? 'https://team.aussie-dev.com.au' : 'https://aussie-team-dev.lendigroup.com.au';
            case Environment.Staging:
                return !lendiGroupTvEnabled ? 'https://team.aussie-stg.com.au' : 'https://aussie-team-stg.lendigroup.com.au';
            case Environment.Preproduction:
                return !lendiGroupTvEnabled
                    ? 'https://team.aussie-preprod.com.au'
                    : 'https://aussie-team-preprod.lendigroup.com.au';
            case Environment.Production:
                return !lendiGroupTvEnabled ? 'https://team.aussie.com.au' : 'https://aussie-team.lendigroup.com.au';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.lendi-dev.net';
            case Environment.Staging:
                return 'https://www.lendi-stg.net';
            case Environment.Preproduction:
                return 'https://www.lendi-preprod.net';
            case Environment.Production:
                return 'https://www.lendi.com.au';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.aussie-dev.com.au';
            case Environment.Staging:
                return 'https://www.aussie-stg.com.au';
            case Environment.Preproduction:
                return 'https://www.aussie-preprod.com.au';
            case Environment.Production:
                return 'https://www.aussie.com.au';
        }
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
export function getURLs(brand, type, environment, lendiGroupTeamView // optional and required to pass only in case of TV else we can ignore to pass
) {
    var baseURL = getBaseURL(brand, type, environment, lendiGroupTeamView);
    var unauthBaseURL = baseURL;
    var authBaseURL = baseURL;
    if (type === Type.Team) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: '',
            authenticated: "".concat(baseURL, "/dashboard/applications"),
            unauthenticated: "".concat(baseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    if (type === Type.Customer) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: "".concat(baseURL, "/sign-in/sign-up/"),
            authenticated: "".concat(authBaseURL),
            unauthenticated: "".concat(unauthBaseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
//# sourceMappingURL=getURLs.js.map